export default "__VITE_ASSET__DKWSKdLe__"